import type { StoredExperience } from "./experience-types";

export const EXPERIENCE_STORAGE_KEY = "doomum_experience";
export const EXPERIENCE_COOKIE_NAME = EXPERIENCE_STORAGE_KEY;
export const EXPERIENCE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24;

export function isStoredExperience(value: unknown): value is StoredExperience {
  return value === "local" || value === "international";
}

export function normalizeStoredExperience(
  value: unknown,
): StoredExperience | null {
  return isStoredExperience(value) ? value : null;
}

export function readExperienceFromSession(): StoredExperience | null {
  if (typeof window === "undefined") return null;

  try {
    return normalizeStoredExperience(
      window.sessionStorage.getItem(EXPERIENCE_STORAGE_KEY),
    );
  } catch {
    return null;
  }
}

export function writeExperienceToSession(experience: StoredExperience) {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(EXPERIENCE_STORAGE_KEY, experience);
  } catch {}
}

export function readExperienceFromDocumentCookie(): StoredExperience | null {
  if (typeof document === "undefined") return null;

  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${EXPERIENCE_COOKIE_NAME}=`));

  if (!cookie) return null;

  return normalizeStoredExperience(decodeURIComponent(cookie.split("=")[1]));
}

export function writeExperienceCookie(experience: StoredExperience) {
  if (typeof document === "undefined") return;

  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:"
      ? "; Secure"
      : "";

  document.cookie = [
    `${EXPERIENCE_COOKIE_NAME}=${encodeURIComponent(experience)}`,
    "Path=/",
    `Max-Age=${EXPERIENCE_COOKIE_MAX_AGE_SECONDS}`,
    "SameSite=Lax",
    secure,
  ].join("; ");
}
